import React, { useEffect, useState } from 'react';
import GalleryManager from './GalleryManager';
import { flattenAlbumPhotos, flattenAlbumVideos } from '../../utils/galleryAlbums';

const FLATTEN_BY_FIELD = {
  photos: flattenAlbumPhotos,
  videos: flattenAlbumVideos,
};

const AlbumsGalleryAdmin = ({
  albums = [],
  onChange,
  mediaField = 'photos',
  galleryType = 'photos',
  emptyAlbumTitle = 'Galerie principale',
  helpText = 'Organisez vos photos par album (Formations, Événements, etc.)',
  deleteConfirm = 'Supprimer cet album et toutes ses photos ?',
}) => {
  const flatten = FLATTEN_BY_FIELD[mediaField] || flattenAlbumPhotos;

  const buildSafeAlbums = (source) =>
    source.length > 0
      ? source
      : [{ id: 'general', title: emptyAlbumTitle, [mediaField]: [] }];

  const [localAlbums, setLocalAlbums] = useState(() => buildSafeAlbums(albums));

  useEffect(() => {
    setLocalAlbums(buildSafeAlbums(albums));
  }, [albums, emptyAlbumTitle, mediaField]);

  const syncAlbums = (nextAlbums) => {
    setLocalAlbums(nextAlbums);
    onChange({
      albums: nextAlbums,
      items: flatten(nextAlbums),
    });
  };

  const handleAlbumField = (index, field, value) => {
    const next = localAlbums.map((album, i) =>
      i === index ? { ...album, [field]: value } : album
    );
    syncAlbums(next);
  };

  const handleAlbumMedia = (index, items) => {
    const next = localAlbums.map((album, i) =>
      i === index ? { ...album, [mediaField]: items } : album
    );
    syncAlbums(next);
  };

  const handleAddAlbum = () => {
    const id = `album-${Date.now()}`;
    syncAlbums([
      ...localAlbums,
      { id, title: 'Nouvel album', [mediaField]: [] },
    ]);
  };

  const handleDeleteAlbum = (index) => {
    if (localAlbums.length <= 1) return;
    if (!window.confirm(deleteConfirm)) return;
    syncAlbums(localAlbums.filter((_, i) => i !== index));
  };

  const handleMoveAlbum = (index, direction) => {
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= localAlbums.length) return;
    const next = [...localAlbums];
    [next[index], next[targetIndex]] = [next[targetIndex], next[index]];
    syncAlbums(next);
  };

  return (
    <div className="albums-gallery-admin">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <p style={{ margin: 0, color: '#64748b', fontSize: '0.9rem' }}>
          {helpText}
        </p>
        <button type="button" className="btn-add-program" onClick={handleAddAlbum}>
          <i className="fas fa-plus" /> Ajouter un album
        </button>
      </div>

      {localAlbums.map((album, index) => (
        <div
          key={album.id || `album-${index}`}
          style={{
            marginBottom: '1.5rem',
            padding: '1rem',
            border: '1px solid #e2e8f0',
            borderRadius: '10px',
            background: '#fafafa',
          }}
        >
          <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-end', marginBottom: '1rem', flexWrap: 'wrap' }}>
            <div className="form-group" style={{ flex: '1 1 220px', margin: 0 }}>
              <label>Nom de l&apos;album</label>
              <input
                type="text"
                value={album.title || ''}
                onChange={(e) => handleAlbumField(index, 'title', e.target.value)}
                placeholder="Ex: Formations cliniques"
              />
            </div>
            <div style={{ display: 'flex', gap: '0.35rem', alignItems: 'center' }}>
              <button
                type="button"
                className="btn-move"
                onClick={() => handleMoveAlbum(index, 'up')}
                disabled={index === 0}
                title="Remonter l'album"
                aria-label="Remonter l'album"
              >
                <i className="fas fa-arrow-up" />
              </button>
              <button
                type="button"
                className="btn-move"
                onClick={() => handleMoveAlbum(index, 'down')}
                disabled={index === localAlbums.length - 1}
                title="Descendre l'album"
                aria-label="Descendre l'album"
              >
                <i className="fas fa-arrow-down" />
              </button>
            </div>
            {localAlbums.length > 1 && (
              <button
                type="button"
                className="remove-btn"
                onClick={() => handleDeleteAlbum(index)}
                title="Supprimer l'album"
              >
                Supprimer l&apos;album
              </button>
            )}
          </div>
          <GalleryManager
            value={album[mediaField] || []}
            onChange={(items) => handleAlbumMedia(index, items)}
            type={galleryType}
          />
        </div>
      ))}
    </div>
  );
};

export default AlbumsGalleryAdmin;
